import * as React from "react";
const SvgFiRrGrateDroplet = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-grate-droplet_svg__a)">
      <path
        fill="#062147"
        d="m22.527 15.457-1.813-1.773a2.467 2.467 0 0 0-3.429 0l-1.82 1.781A4.97 4.97 0 0 0 14 19c0 1.336.521 2.592 1.464 3.535A4.97 4.97 0 0 0 19 24a4.97 4.97 0 0 0 3.535-1.465A4.97 4.97 0 0 0 24 19a4.97 4.97 0 0 0-1.473-3.543m-1.406 5.664c-1.134 1.134-3.11 1.134-4.242 0A2.98 2.98 0 0 1 16 19c0-.802.312-1.555.871-2.113l1.812-1.773a.45.45 0 0 1 .631 0l1.806 1.766a2.98 2.98 0 0 1 .879 2.121 2.98 2.98 0 0 1-.879 2.121zM16 12a1 1 0 0 0 1-1V2c1.654 0 3 1.346 3 3v5a1 1 0 1 0 2 0V5c0-2.757-2.243-5-5-5H5C2.243 0 0 2.243 0 5v12c0 2.757 2.243 5 5 5h6a1 1 0 0 0 1-1v-9zM15 2v8h-3V2zm-5 8H7V2h3zM5 2v8H2V5c0-1.654 1.346-3 3-3M2 17v-5h3v8c-1.654 0-3-1.346-3-3m8 3H7v-8h3z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-grate-droplet_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrGrateDroplet;
